import React, { Component } from "react";
import {
  Box,
  Grid,
  Typography,
  Breadcrumbs,
  Link,
  Checkbox,
} from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import EditIcon from "@mui/icons-material/Edit";
import CtTxt from "./CustomTool/CtTxt";
import CtDtp from "./CustomTool/CtDtp";
import CtCmb from "./CustomTool/CtCmb";
import CtBtn from "./CustomTool/CtBtn";
import MaterialTable from "./CustomTool/MaterialTable";
// import "./AMCRenewalList.css";
import {
  get_YMD_from_SYS,
  get_30DaysBack_FromCurrentDate,
} from "../SystemUtility/SystemUtility";
import { connect } from "react-redux";
import {
  mapSetUserPrivileges_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import { withRouter } from "../HOC/withRouter";
import { useNavigate } from "react-router-dom";

class AMCRenewalList extends Component {
  state = {
    formData: {
      liftCode: "",
      fromDate: get_30DaysBack_FromCurrentDate(new Date()),
      toDate: get_YMD_from_SYS(new Date()),
      branch: "",
      renewalMonth: "",
      renewalYear: "",
      renewalType: "",
    },
    columns: [
      {
        accessorKey: "branchName",
        header: "Branch Name",
        enableColumnActions: false,
        // enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "siteName",
        header: "Site Name",
        enableColumnActions: false,
        // enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "contractNo",
        header: "Contract No.",
        enableColumnActions: false,
        // enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "documentNo",
        header: "Document No.",
        enableColumnActions: false,
        // enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "contractType",
        header: "Contract Type",
        enableColumnActions: false,
        // enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "totalLift",
        header: "Total Lift",
        align: "center",
        enableColumnActions: false,
        // enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "currentPeriod",
        header: "Current Period",
        enableColumnActions: false,
        // enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "currentPrice",
        header: "Current Price",
        enableColumnActions: false,
        // enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "proposedPrice",
        header: "Proposed Price",
        enableColumnActions: false,
        // enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "confirmPrice",
        header: "Confirm Price",
        enableColumnActions: false,
        // enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "duration",
        header: "Duration",
        enableColumnActions: false,
        // enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "contractStage",
        header: "Contract Stage",
        enableColumnActions: false,
        // enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
    ],
    rows: [
      {
        ID: 1,
        branchName: "Bhavnagar",
        siteName: "Aarohi Complex",
        contractNo: "101",
        documentNo: "TOP/AMC/BVN/25-26/03",
        contractType: "Popular",
        totalLift: "2",
        currentPeriod: "01/02/2025 - 01/02/2026",
        currentPrice: "100000",
        proposedPrice: "100000",
        confirmPrice: "100000",
        duration: "01/01/2025 TO 31/12/2025",
        contractStage: "Follow Up",
        selected: true,
      },
    ],
  };

  componentDidMount() {
    document.title = "AMC Renewal List";
    localStorage.setItem("Heading", "AMC Renewal");
    document.getElementById("liftCode").focus();
  }

  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  handleSelectRow = (rowId, checked) => {
    const rows = this.state.rows.map((row) =>
      row.ID === rowId ? { ...row, selected: checked } : row,
    );
    this.setState({ rows });
  };

  clearInfo = () => {
    this.setState(
      {
        formData: {
          liftCode: "",
          fromDate: "",
          toDate: "",
          branch: "",
          renewalMonth: "",
          renewalYear: "",
          renewalType: "",
        },
      },
      () => {
        document.getElementById("iftCod")?.focus();
      },
    );
  };
  GenerateRenewal = () => {
    if (!this.validationAMCRenewal()) return;
    this.props.toastMsg("success", "AMC Renewal Generate Successfully");
    this.clearInfo();

    // navigate after save if needed
    this.props.navigateTo("AMCRenewal");
  };

  validationAMCRenewal = () => {
    const { formData } = this.state;

    if (!formData.liftCode) {
      this.props.toastErrorMsg("Enter Lift Code", "liftCode");
      return false;
    }

    if (!formData.fromDate) {
      this.props.toastErrorMsg("Select From Date", "fromDate");
      return false;
    }

    if (!formData.toDate) {
      this.props.toastErrorMsg("Select To Date", "toDate");
      return false;
    }

    // Date comparison
    if (new Date(formData.fromDate) > new Date(formData.toDate)) {
      this.props.toastErrorMsg(
        "From Date must be less than To Date",
        "fromDate",
      );
      return false;
    }

    if (!formData.branch) {
      this.props.toastErrorMsg("Select Branch", "branch");
      return false;
    }

    if (!formData.renewalMonth) {
      this.props.toastErrorMsg("Select Renewal Month", "renewalMonth");
      return false;
    }

    if (!formData.renewalYear) {
      this.props.toastErrorMsg("Select Renewal Year", "renewalYear");
      return false;
    }

    if (!formData.renewalType) {
      this.props.toastErrorMsg("Select Renewal Type", "renewalType");
      return false;
    }

    return true;
  };

  render() {
    const { formData, rows, columns } = this.state;
    return (
      <form>
        <Box>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="#/Dashboard">
              Dashboard
            </Link>
            <Link underline="hover" color="inherit" href="#/AMCDashboard">
              AMC Dashboard
            </Link>
            <Typography sx={{ color: "text.primary" }}>AMC Renewal</Typography>
          </Breadcrumbs>

          {/* <Typography>AMC Renewal List</Typography> */}

          <Grid container spacing={2} marginTop={2}>
            <Grid item>
              <CtTxt
                id="liftCode"
                label="Lift Code"
                value={formData.liftCode}
                width={220}
                maxLength={100}
                handleOnChange={this.handleOnChange}
                onKeyDown={this.props.onKeyDown}
                nextCtrlID={"fromDate"}
              />
            </Grid>
            <Grid item>
              <CtDtp
                id="fromDate"
                label="From Date"
                value={formData.fromDate}
                width={160}
                maxLength={100}
                handleOnChange={this.handleOnChange}
                onKeyDown={this.props.onKeyDown}
                nextCtrlID={"toDate"}
              />
            </Grid>
            <Grid item>
              <CtDtp
                id="toDate"
                label="To Date"
                value={formData.toDate}
                width={160}
                maxLength={100}
                handleOnChange={this.handleOnChange}
                onKeyDown={this.props.onKeyDown}
                nextCtrlID={"branch"}
              />
            </Grid>
            <Grid item>
              <CtCmb
                id="branch"
                label="Branch"
                value={formData.branch}
                items={["Bhavnagar", "Rajkot", "Baroda", "Surat"]}
                width={200}
                maxLength={100}
                handleOnChange={this.handleOnChange}
                onKeyDown={this.props.onKeyDown}
                nextCtrlID={"renewalMonth"}
              />
            </Grid>
            <Grid item>
              <CtCmb
                id="renewalMonth"
                label="Renewal Month"
                value={formData.renewalMonth}
                items={[
                  "January",
                  "February",
                  "March",
                  "April",
                  "May",
                  "June",
                  "July",
                  "August",
                  "September",
                  "October",
                  "November",
                  "December",
                ]}
                width={200}
                maxLength={100}
                handleOnChange={this.handleOnChange}
                onKeyDown={this.props.onKeyDown}
                nextCtrlID={"renewalYear"}
              />
            </Grid>
            <Grid item>
              <CtCmb
                id="renewalYear"
                label="Renewal Year"
                value={formData.renewalYear}
                items={["2024", "2025", "2026"]}
                width={200}
                maxLength={100}
                handleOnChange={this.handleOnChange}
                onKeyDown={this.props.onKeyDown}
                nextCtrlID={"renewalType"}
              />
            </Grid>
            <Grid item>
              <CtCmb
                id="renewalType"
                label="Renewal Type"
                value={formData.renewalType}
                items={["All", "Potential", "Submitted", "Done", "Lost"]}
                width={220}
                maxLength={100}
                handleOnChange={this.handleOnChange}
                onKeyDown={this.props.onKeyDown}
                nextCtrlID={""}
              />
            </Grid>
            <Grid item>
              <CtBtn
                label="LOAD"
                className="secondary-button"
                onClick={() => {}}
              />
            </Grid>
            <Grid item>
              <CtBtn
                label="WHATSAPP"
                className="success-button"
                onClick={() => {}}
              />
            </Grid>
            <Grid item>
              {/* <CtBtn
                label="Generate Renewal"
                className="secondary-button"
                onClick={this.props.navigateTo("/AMCRenewal")}
              /> */}
              <CtBtn label="GENERATE RENEWAL" onClick={this.GenerateRenewal} />
            </Grid>
          </Grid>

          <Box marginTop={2}>
            <MaterialTable
              columnsdata={columns}
              rowsdata={rows}
              rowsPerPage={25}
              tblmaxHeight={420}
              csvFileName={"AMC Renewal"}
              showColumnFilters={false}
              actionColSize={140}
              density={"compact"}
              hideBottomToolbar={true}
              hideColIdList={[""]}
            />
          </Box>
        </Box>
      </form>
    );
  }
}

function WithNavigate(props) {
  let navigate = useNavigate();
  return <AMCRenewalList {...props} navigate={navigate} />;
}
export default connect(
  mapStatetoProps,
  mapSetUserPrivileges_ToProps,
)(HoCtToastContainer(HOCVerifyIsUser(withRouter(WithNavigate))));
